module.exports = __webpack_public_path__ + "img/0.29b2f09f.jpg";